import React, { useMemo, useState } from "react";
import "../barChart/barchart.css";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const TOOLTIP_WIDTH = 120;

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;

  // Top bar is pendingfeedback (dark green)
  const pending = payload[0].payload.receivedFeedback;
  const total = payload[0].payload.pendingfeedback;

  return (
    <div
      className="relative flex flex-col items-center"
      style={{ transform: "translateY(calc(-100% - 9px))" }}
    >
      <div
        className="text-white rounded-lg shadow-lg text-sm font-semibold text-center"
        style={{
          backgroundColor: "#089848",
          width: TOOLTIP_WIDTH,
          padding: "20px 0 0 0",
        }}
      >
        <p style={{ fontSize: "14px", marginBottom:"5px" }}>Total: {total + pending}</p>
        <p style={{ fontSize: "14px" }}>Pending:{pending}</p>

      </div>

      <div
        style={{
          width: 0,
          height: 0,
          borderLeft: "7px solid transparent",
          borderRight: "7px solid transparent",
          borderTop: "9px solid #089848",
          marginTop: "-1px",
        }}
      />
    </div>
  );
};

const CareBarChartComponent = ({ SalesReport }) => {
  const rawData =
    SalesReport?.data?.graph_stats?.pending_stats?.pending_feedback_graph || [];

  const data = rawData.map((item) => {
    const pending = item.count || 0;
    const total = item.total_feedback_count || 0;
    const received = Math.max(total - pending,);

    return {
      month: item.label,
      receivedFeedback: pending,     // Light green - bottom
      pendingfeedback: received,       // Dark green - top (pending)
      totalFeedback: total,
    };
  });

  const totalpendingfeedback =
    SalesReport?.data?.graph_stats?.pending_stats?.total_pending_feedback || 0;

  const totalbookings =
    SalesReport?.data?.graph_stats?.pending_stats?.total_bookings || 0;

  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
  const [isTooltipActive, setIsTooltipActive] = useState(false);

  const yAxisConfig = useMemo(() => {
    if (!data.length) return { domain: [0, 100], ticks: [] };

    const maxTotal = Math.max(...data.map((d) => d.totalFeedback));
    const paddedMax = maxTotal === 0 ? 10 : maxTotal * 1.05;
    const step = Math.ceil(paddedMax / 6 / 10) * 10 || 10;
    const domainMax = Math.ceil(paddedMax / step) * step;

    return {
      domain: [0, domainMax],
      ticks: Array.from({ length: Math.floor(domainMax / step) + 1 }, (_, i) => i * step),
    };
  }, [data]);

  const handleTooltip = (e) => {
    if (!e) return;

    setTooltipPos({
      x: e.x + e.width / 2 - TOOLTIP_WIDTH / 2,
      y: e.y - 10,
    });
    setIsTooltipActive(true);
  };

  return (
    <div className="bg-white rounded-2xl p-6 max-w-md barchart-parent">
      <div className="mb-6">
        <div className="flex items-center justify-between" style={{ flexWrap: "wrap" }}>
          <p className="mb-0" style={{ fontSize: "26px", fontWeight: "bold", color: "black", }}>
            Pending Feedback
          </p>

          <div
            style={{
              border: "1px solid #D4FFE7",
              borderRadius: "130px",
              padding: "10px 14px",
              backgroundColor: "#D4FFE7",
            }}
            className="flex items-center gap-2"
          >
            <p style={{ fontSize: "18px", marginBottom: 0 }}>{totalbookings}</p>
            <p style={{ fontSize: "18px", marginBottom: 0 }}>Total Booking</p>
          </div>
        </div>

        <h2 className="text-3xl font-bold mt-1">{totalpendingfeedback}</h2>
      </div>

      <hr className="border-gray-100 mb-14" />

      <div style={{ width: "100%", height: 390, marginTop: "40px" }}>
        <ResponsiveContainer>
          <BarChart
            data={data}
            margin={{ top: 20, right: 10, left: -20 }}
            onMouseLeave={() => setIsTooltipActive(false)}
          >
            <CartesianGrid vertical={false} strokeDasharray="4 4" />
            <XAxis dataKey="month" axisLine={false} tickLine={false} dy={5} />
            <YAxis
              domain={yAxisConfig.domain}
              ticks={yAxisConfig.ticks}
              axisLine={false}
              tickLine={false}
            />

            <Tooltip
              content={<CustomTooltip />}
              position={tooltipPos}
              active={isTooltipActive}
              isAnimationActive={false}
              cursor={{ fill: "transparent" }}
              wrapperStyle={{ pointerEvents: "none" }}
            />

            {/* Bottom: Already received - Light green */}
            <Bar
              dataKey="receivedFeedback"
              stackId="a"
              barSize={25}
              fill="#089848"
              radius={[0, 0, 0, 0]}
              onMouseMove={handleTooltip}
            />

            {/* Top: Pending - Dark green */}
            <Bar
              dataKey="pendingfeedback"
              stackId="a"
              barSize={25}
              fill="#dcfce7"
              radius={[6, 6, 0, 0]}
              onMouseMove={handleTooltip}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CareBarChartComponent;